import { createAction } from '@reduxjs/toolkit';
import { BundleProductVariant } from '../../blocks/bundlePdp/BundleOptions/types';

type SetPriceTotalParam =
  | undefined
  | {
      centAmount: number;
    };

type SetSelectedAttributesValuesParam = {
  size?: string;
  color?: string;
  [attributeName: string]: string | undefined;
};

type SetSelectedVariantsForBundleItemProductsParam = {
  selectedVariantsForBundleItemProducts: {
    [k: string]:
      | {
          sku: string;
          masterVariant?: boolean | undefined;
          attributes?: {
            name: string;
            key: string;
            label: string;
          }[];
          price: {
            centAmount: number;
          };
          discount: {
            centAmount: number;
          };
          isProductTest?: boolean;
          image?: string;
          productType?: string;
        }[]
      | (BundleProductVariant | undefined)[];
  };
};

export const setPriceTotal = createAction<SetPriceTotalParam>(
  'bundlePdp/setPriceTotal',
);

export const setDiscountPriceTotal = createAction<SetPriceTotalParam>(
  'bundlePdp/setDiscountPriceTotal',
);

export const setSelectedAttributesValues =
  createAction<SetSelectedAttributesValuesParam>(
    'bundlePdp/setSelectedAttributeValues',
  );

export const setSelectedVariantsForBundleItemProducts =
  createAction<SetSelectedVariantsForBundleItemProductsParam>(
    'bundlePdp/setSelectedVariantsForBundleItemProducts',
  );
